import axios from "axios";
import { storage } from "./scopedStorage";

// There is no shared axios instance in this app — every component imports
// the bare `axios` package directly (see CLAUDE.md). That default export is
// still a single module-level instance though, so a response interceptor
// registered on it here, once, at app bootstrap, applies to every axios call
// anywhere in the app without touching any of those call sites.

// Longest/most specific prefix first: "/dashboards" (collections) must be
// checked before "/dashboard" (aggregation), which is one of its prefixes.
const LOGIN_PATH_BY_PREFIX = [
  ["/dashboards", "/collections"],
  ["/dashboard", "/aggregation"],
  ["/factory", "/factoryLogin"],
  ["/admin-dashboard", "/admin"],
  ["/admin", "/admin"],
  ["/drivers", "/drivers"],
];

const resolveLoginPath = () => {
  const path = window.location.pathname;
  const match = LOGIN_PATH_BY_PREFIX.find(([prefix]) => path.startsWith(prefix));
  return match ? match[1] : "/aggregation";
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    // A wrong password/OTP on a login/reset call is a rejected attempt, not
    // a dead session — there is no token yet for it to have expired. Every
    // login/OTP/reset endpoint in this app lives under "/auth/" or ends in
    // "/login" (see each stakeholder's auth/login).
    const isAuthEndpoint = url.includes("/auth/") || url.endsWith("/login");
    const hadToken = !!storage.getItem("token");

    // A 401 on an already-authenticated call means the session is dead on
    // the server (expired, revoked, or overwritten by a login elsewhere) —
    // redirect straight to login instead of leaving the user on a page that
    // will keep failing silently until they notice and refresh.
    if (status === 401 && hadToken && !isAuthEndpoint) {
      storage.clearScoped();
      window.location.href = resolveLoginPath();
    }

    return Promise.reject(error);
  }
);
